import { render, staticRenderFns } from "./PersonEncode.vue?vue&type=template&id=bcfafa0a"
import script from "./PersonEncode.vue?vue&type=script&lang=js"
export * from "./PersonEncode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports